// extracted by mini-css-extract-plugin
export default {"extensions-menu__content":"extensionsMenu_extensions-menu__content__AvjMI","extensions-menu__container":"extensionsMenu_extensions-menu__container__-yKH9"};